<ad-detail-category-tag>
    <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
        {props.item.title}
    </h2>
    <div each="{category in props.item.items}">
        <h3 class="heading-05 margin-spacing-2_bottom">{ category.title }</h3>
        <ul class="scope_list margin-spacing-2_bottom">
            <li class="scope_list-item" each="{ title in category.items }">
                <span class="skill_label">{title}</span>
            </li>
        </ul>
    </div>
    <script>
        export default {
            onMounted(props, state) {
            }
        }
    </script>
</ad-detail-category-tag>
